<template>
  <div class="work-window">
    <LKNavigationPanel />
    <div class="lk-work-window ">
      <RouterView />
    </div>
  </div>
</template>

<script setup>
import LKNavigationPanel from "@/pages/LKPage/LKNavigationPanel.vue";
</script>

<style lang="scss">


.work-window {
  background-color: var(--background-bg-main);
  position: relative;
  min-width: 710px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  gap: 14px;
  min-height: 700px;
  height: calc(100vh - 92px);
}

.lk-work-window {
  background-color: $background-color-content;
  border-radius: 10px;
  display: grid;
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
}
</style>
